import React from 'react';

const BreadcrumbSchema = ({ items }) => {
  const baseUrl = process.env.REACT_APP_BASE_URL || 'https://houseplandirect.com';
  
  const schema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": `${baseUrl}${item.path}`
    }))
  };

  return (
    <script type="application/ld+json">
      {JSON.stringify(schema)}
    </script>
  );
};

export default BreadcrumbSchema;
